import HttpV2 from '../httpv2';
import { SET } from './constants';
import { SentryService } from '../../modules/infra/observability/sentry';

export const setCart = (id = '') => ({
  type: SET,
  payload: id,
});

export const createShopCart = (shopId, sale) => HttpV2.post(`/shop/${shopId}/cart`, sale);
export const createBarberCart = (barberId, sale) => HttpV2.post(`/barber/${barberId}/cart`, sale);

export const updateShopCart = (shopId, cartId, sale) => HttpV2.post(`/shop/${shopId}/cart/${cartId}`, sale);
export const updateBarberCart = (barberId, cartId, sale) => HttpV2.post(`/barber/${barberId}/cart/${cartId}`, sale);

export const fetchShopCart = (shopId, id) => HttpV2.get(`/shop/${shopId}/cart/${id}`);
export const fetchBarberCart = (barberId, id) => HttpV2.get(`/barber/${barberId}/cart/${id}`);

export const checkoutShopCart = (shopId, id, tips) =>
  HttpV2.post(`/shop/${shopId}/cart/${id}/checkout`, { tips }).catch((err) => {
    SentryService.captureException(err);
    throw err;
  });

export const checkoutBarberCart =
  (barberId, id, tips) => HttpV2.post(`/barber/${barberId}/cart/${id}/checkout`, { tips }).catch((err) => {
    SentryService.captureException(err);
    throw err;
  });

export const createShopSale = (shopId, sale) => HttpV2.post(`/shop/${shopId}/sale`, sale);
export const createBarberSale = (barberId, sale) => HttpV2.post(`/barber/${barberId}/sale`, sale);
